/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html, nothing} from 'lit';
import {createRef, ref} from 'lit/directives/ref.js';
import styles from './chat-widget.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class ChatWidget extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			hideTrigger: {
				attribute: 'hide-trigger',
				type: Boolean
			}
		};
	}

	modal = createRef();

	constructor () {
		super();

		this.hideTrigger = false;
	}

	render () {
		return html`
			<rb-chat-widget-modal lock="true" small="true" direction="center" animation="slide" header="false" content-padding="false" class="talk-to-an-expert-modal" ${ref(this.modal)}>
				<div slot="content">${this.renderModalContent()}</div>
				<slot slot="trigger" name="trigger"></slot>
				${this.hideTrigger ? nothing : html`
					<button slot="trigger" class="talk-to-an-expert">
						<span class="icon-chat-bubble expert--icon" aria-hidden="true"></span>
						<span class="expert--text">Talk to an Expert</span>
					</button>
				`}
			</rb-chat-widget-modal>
		`;
	}

	renderModalContent () {
		return html`
			<div class="chat-widget-modal-content">
				<div class="chat-widget-modal--title">Talk to An Expert</div>
				<div class="chat-widget-modal--callout">
					Borsheims' Customer Care team and Graduate Gemologists are here to assist you select or design the ring of your dreams.
				</div>
				<div class="chat-widget-modal--action">
					<span class="chat-widget-modal--action-icon icon-chat-bubble" aria-hidden="true"></span>
					<span class="chat-widget-modal--text">
						<span class="chat-widget-modal--action-label">Call or Text</span>
						<a href="tel:14023910400" class="chat-widget-modal--action-cta" @click="${() => this.trackClick('Call or Text')}">402.391.0400</a>
					</span>
				</div>
				<div class="chat-widget-modal--action">
					<span class="chat-widget-modal--action-icon icon-calendar" aria-hidden="true"></span>
					<span class="chat-widget-modal--text">
						<span class="chat-widget-modal--action-label">Book An Appointment</span>
						<a href="${window?.mivaJS?.urls?.appt}" target="_blank" class="chat-widget-modal--action-cta" @click="${() => this.trackClick('Book Now')}">Book Now</a>
					</span>
				</div>
			</div>
		`;
	}

	trackClick (label) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'ga_event',
			/* eslint-disable camelcase */
			ga_event_action: 'Talk to an Expert - Click',
			ga_event_category: 'Ring Builder',
			ga_event_label: label,
			ga_event_non_interaction: false
			/* eslint-enable camelcase */
		});
	}
};

defineCustomElement('rb-chat-widget', ChatWidget);
